(function() {
    'use strict';

    angular
        .module('app.paquetes')
        .run(appRun);

    // appRun.$inject = ['routehelper'];

    /* @ngInject */
    function appRun(routehelper) {
        routehelper.configureRoutes(getRoutes());
    }

    function getRoutes() {
        return [
            {
                url: '/paquetes',
                config: {
                    templateUrl: 'app/paquetes/list.html',
                    controller: 'paquetes.List',
                    controllerAs: 'vm',
                    title: 'List'
                }
            },
            {
                url: '/editar-paquete/:id?',
                config: {
                    templateUrl: 'app/paquetes/edit.html',
                    controller: 'paquetes.Edit',
                    controllerAs: 'vm',
                    title: 'Edit'
                }
            }
        ];
    }
})();
